@if (usersScroll()) {
    <div [formGroup]="form" class="input-grid input-grid-gaps">
        <app-select-input
            [infiniteScroll]="usersScroll()"
            valueKey="id"
            id="userId"
            [form]="form"
            [showClear]="false"
            filterBy="name,surname,email"
        >
            <ng-template #item let-item>
                {{ item | formatPerson }}
            </ng-template>
            <ng-template #selectedItem let-item>
                {{ item | formatPerson }}
            </ng-template>
        </app-select-input>
    </div>
}
